import TrainSummary from './TrainSummary';

export default TrainSummary;